var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DynamicNavigation',{attrs:{"breadcrumbs":_vm.breadcrumbs,"hide-on-mobile":true}}),_vm._v(" "),_c('AllPackagesSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }